jQuery(document).ready(function($) {
    $(document).ready(function() {
        $('h3[kerdes]').on('click', function() {
            // Lekérdezzük a kérdés attribútumában lévő számot
            var kerdesSzam = $(this).attr('kerdes');
            
            // Kiválasztjuk a válasz elemet a megfelelő 'valasz' attribútummal
            var valasz = $('div[valasz="' + kerdesSzam + '"]');
            
            // A válasz elemhez hozzáadjuk vagy eltávolítjuk az 'active' osztályt
            $('.valasz').removeClass('active');

            valasz.toggleClass('active');
        });
    });
});